import { vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "qrcode-stream-wrapper" };
const _hoisted_2 = {
    ref: "video",
    class: "qrcode-stream-camera",
    autoplay: "",
    muted: "",
    playsinline: ""
};
const _hoisted_3 = {
    ref: "pauseFrame",
    class: "qrcode-stream-camera"
};
const _hoisted_4 = {
    ref: "trackingLayer",
    class: "qrcode-stream-overlay"
};
const _hoisted_5 = { class: "qrcode-stream-overlay" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _withDirectives(_createElementVNode("video", _hoisted_2, null, 512), [
            [_vShow, $options.shouldScan]
        ]),
        _withDirectives(_createElementVNode("canvas", _hoisted_3, null, 512), [
            [_vShow, !$options.shouldScan]
        ]),
        _createElementVNode("canvas", _hoisted_4, null, 512),
        _createElementVNode("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
    ]));
}
